// extracted by mini-css-extract-plugin
export default {"imgIcon":"Register_imgIcon__-emZo","containerCustomize":"Register_containerCustomize__84DdS","green_btn":"Register_green_btn__FFv0H"};